import { IAutocomplete, IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";

const { venueProperties, errors } = copy;

export const getFormFields = ({
  showExtendedInfo = true,
}: {
  showExtendedInfo?: boolean;
}): IFormFields => {
  const fields: IFormFields = [
    {
      name: "title",
      label: venueProperties.name.title,
      type: IFieldType.text,
      autocomplete: IAutocomplete.organization,
      validation: {
        required: errors.required,
      },
    },
  ];

  if (showExtendedInfo) {
    fields.push(
      {
        name: "alternativeName",
        label: venueProperties.alternativeName.title,
        type: IFieldType.text,
        autocomplete: IAutocomplete.organization,
        note: venueProperties.alternativeName.note,
      },
      {
        name: "contact",
        hideContainer: true,
        fields: [
          {
            name: "website",
            label: venueProperties.website.title,
            type: IFieldType.website,
            autocomplete: IAutocomplete.url,
            note: venueProperties.website.note,
          },
          {
            name: "email",
            label: venueProperties.email.title,
            type: IFieldType.email,
            note: venueProperties.email.note,
          },
          {
            name: "phone",
            label: venueProperties.phoneNumber.title,
            type: IFieldType.phone,
          },
        ],
      }
    );
  }

  return fields;
};

export const defaultValues = {
  contact: {
    phone: {
      code: "BE",
    },
  },
};
